// extracted by mini-css-extract-plugin
export default {"rouned_gainful_button":"tr","court":"ur","disabled":"vr","outlined":"wr","white_button":"xr"};
    if(module.hot) {
      // 1715632474830
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  